/** Google Plus Code pattern — e.g. `GJ4H+JC7`, `8FW4V75C+8WW`. */
const PLUS_CODE_PATTERN =
  /^[23456789CFGHJMPQRVWX]{4,}\+[23456789CFGHJMPQRVWX]{2,}$/i;

const NUMERIC_ONLY_PATTERN = /^[\d#./\-\s,]+$/;
const PIN_CODE_PATTERN = /^\d{5,6}$/;

const ADMIN_REGION_PATTERN =
  /^(india|telangana|andhra pradesh|karnataka|maharashtra|tamil nadu|delhi|uttar pradesh|west bengal|gujarat|rajasthan|punjab|kerala|haryana|bihar|odisha|madhya pradesh|assam|jharkhand|chhattisgarh|goa|uttarakhand|himachal pradesh|tripura|meghalaya|manipur|nagaland|arunachal pradesh|mizoram|sikkim)$/i;

function isPlusCode(value: string): boolean {
  const normalized = value.trim().replace(/\s/g, "");
  return PLUS_CODE_PATTERN.test(normalized);
}

function isSkippablePart(part: string): boolean {
  const trimmed = part.trim();
  if (!trimmed) return true;
  if (isPlusCode(trimmed)) return true;
  if (NUMERIC_ONLY_PATTERN.test(trimmed)) return true;
  if (PIN_CODE_PATTERN.test(trimmed.replace(/\s/g, ""))) return true;
  if (ADMIN_REGION_PATTERN.test(trimmed)) return true;
  return false;
}

/**
 * Extracts a human-friendly locality (area name) from a full location string.
 * Skips plus codes, pin codes, house numbers, and state/country segments.
 */
export function extractLocalityFromAddress(
  fullAddress: string,
  preferredLocality?: string
): string {
  const parts = fullAddress
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);

  for (const part of parts) {
    if (!isSkippablePart(part)) {
      return part;
    }
  }

  const preferred = preferredLocality?.trim();
  if (preferred && !isSkippablePart(preferred)) {
    return preferred;
  }

  const fallback = fullAddress.trim();
  if (fallback && !isSkippablePart(fallback)) {
    return fallback;
  }

  return parts.find((part) => !isPlusCode(part))?.trim() || fullAddress.trim() || "—";
}
